import * as yup from 'yup';
import {i18n2} from '../../i18n/i18n';

export const ProfileSchema = (selectProfilesGrid = null) =>
  yup.object({
    iD_Profile: yup.number().label(i18n2._('#Perfil')),
    name: yup
      .string()
      .max(100, i18n2._('Maximo 100 caracteres'))
      .required(i18n2._('Este campo es obligatorio'))
      .label(i18n2._('Perfil')),
    iD_Sector: yup
      .number()
      .label(
        selectProfilesGrid === 'selectProfilesGrid'
          ? i18n2._('Sector')
          : i18n2._('#Sector'),
      ),
    sector_Name: yup.string().label(i18n2._('Sector')),
    copyProfile: yup.bool().label(i18n2._('Copiar perfil')),
    profileToCopy: yup.object().label(i18n2._('Perfiles')),
    revision: yup.number().default(0).label(i18n2._('Revision')),
    reason: yup
      .string()
      .max(255)
      .required(i18n2._('Este campo es obligatorio'))
      .label(i18n2._('Motivo')),
    updateDate: yup.date().label(i18n2._('Fecha de actualizacion')),
    updatedBy: yup.string().label(i18n2._('Actualizado por')),
    deleted: yup.bool().label(i18n2._('Eliminado')),
  });
